import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Environment } from 'src/assets/types/interface/environment.interface';
import { PaginatorInterface } from 'src/assets/types/interface/table-items.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly apiUrl = environment.WO_API_URL;
  constructor(private http: HttpClient) {}

  getEnvironments(companyUuid: string | undefined): Observable<Environment[]> {
    const access_token = localStorage.getItem('access_token');
    return this.http.get<Environment[]>(
      `${this.apiUrl}/environment/${companyUuid}/all`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }

  createEnvironment(
    companyUuid: string | undefined,
    environment: Partial<Environment>,
  ): Observable<HttpResponse<Environment>> {
    const access_token = localStorage.getItem('access_token');
    return this.http.post<Environment>(
      `${this.apiUrl}/environment/${companyUuid}`,
      environment,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  updateEnvironment(
    environmentUuid: string,
    data: Partial<Environment>,
  ): Observable<HttpResponse<Environment>> {
    const access_token = localStorage.getItem('access_token');
    return this.http.patch<Environment>(
      `${this.apiUrl}/environment/${environmentUuid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  deleteEnvironment(
    environment: Environment,
  ): Observable<HttpResponse<Environment>> {
    const access_token = localStorage.getItem('access_token');
    const updateEnvironment = {
      name: environment.name,
      details: environment.details,
      status: 'INACTIVE',
    };
    return this.http.patch<Environment>(
      `${this.apiUrl}/environment/${environment.uuid}`,
      updateEnvironment,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  getEnvironment(environmentUuid: string) {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.get<Environment>(
      `${this.apiUrl}/environment/${environmentUuid}/one`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  getEnvironmentsByTenant(): Observable<HttpResponse<Environment[]>> {
    const access_token = localStorage.getItem('access_token');
    return this.http.get<Environment[]>(`${this.apiUrl}/environment/tenants`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      observe: 'response',
    });
  }

  getEnvironmentByTenantPage(
    take: number,
    page: number,
    filters?: {
      name?: string;
      companies?: string[];
    },
  ): Observable<PaginatorInterface> {
    const access_token = localStorage.getItem('access_token');
    let params = new HttpParams().set('name', filters?.name || '');

    (filters?.companies || []).forEach((status) => {
      params = params.append('companies', status);
    });

    return this.http.get<PaginatorInterface>(
      `${this.apiUrl}/environment/limit/${take}/page/${page}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        params,
      },
    );
  }
}
